export const getStartingLocale = (): string | undefined => {
  const browserLanguage = getLanguageFromLocale(getBrowserLocale())
  if (browserLanguage && getSupportedLocales()?.includes(browserLanguage)) {
    return browserLanguage
  }

  return import.meta.env.VITE_I18N_LOCALE || import.meta.env.VITE_I18N_FALLBACK_LOCALE
}

export const getSupportedLocales = (): string[] | undefined => {
  if (!import.meta.env.VITE_I18N_SUPPORTED_LOCALES) {
    return []
  }

  return import.meta.env.VITE_I18N_SUPPORTED_LOCALES?.split(',')
}

export const getLanguageFromLocale = (locale: string): string => {
  return locale.split('-')[0]
}

export const getBrowserLocale = (): string => {
  const navigatorLocale = navigator.languages !== undefined ? navigator.languages[0] : navigator.language

  if (!navigatorLocale) {
    return ''
  }

  return navigatorLocale
}
